import Profile from '@/services/apiCalls/profile/Profile'
import { Auth } from 'aws-amplify'
import router from '@/router'
import ErrorHandler from '@/utils/ErrorHandler'
const currentUser =
  (localStorage.getItem('currentUser') && JSON.parse(localStorage.getItem('currentUser'))) || null

export default {
  namespaced: true,
  state: {
    isLoggedIn: !!localStorage.getItem('authenticated') || false,
    user: currentUser,
    orgInfo: JSON.parse(localStorage.getItem('orgInfo')) || null,
    registration: {
      userInfo: {
        name: '',
        lastName: '',
        email: '',
        password: '',
        cellPhone: '',
        organizationId: '',
        organizationScheme: '',
        region: '',
        country: '',
      },
      isRegionSchemePresent: true,
    },
  },
  getters: {
    contactPerson(state) {
      return state.user.given_name + ' ' + state.user.family_name
    },
    orgId(state) {
      if (state.user) {
        return state.user['custom:org_ids']
      }
      return ''
    },
    userInfo(state) {
      return state.registration.userInfo
    },
    orgLogo(state) {
      return state.orgInfo.logo || require('@/assets/img/team.png');
    },
  },
  actions: {
    async signOut({ commit }) {
      await Auth.signOut()
      localStorage.removeItem('currentUser')
      localStorage.removeItem('orgInfo')
      localStorage.removeItem('authenticated')
      commit('setAuthState', {
        isAuthenticated: false,
        user: null,
      })
      router.push({ name: 'login' })
    },
    async signedIn({ commit, dispatch }) {
      const currentUser = await Auth.currentAuthenticatedUser()
      const credentials = await Auth.currentCredentials()

      commit('setAuthState', {
        isLoggedIn: true,
        user: currentUser.attributes,
      })

      localStorage.setItem('authenticated', true)
      localStorage.setItem('identityId', credentials.identityId)
      localStorage.setItem('currentUser', JSON.stringify(currentUser.attributes))

      dispatch('getStarredTendersIds', null, { root: true })
      dispatch('getUserProfile', null, { root: true })
      router.push({ path: '/' })
    },
    async getOrganization({ commit }) {
      const currentUser = await Auth.currentAuthenticatedUser()
      return new Promise((resolve, rej) => {
        Profile.organization
          .getOrganization(currentUser.attributes['custom:org_ids'])
          .then((res) => {
            if (res.data.getOrganization) {
              resolve(res.data.getOrganization)
              localStorage.setItem('orgInfo', JSON.stringify(res.data.getOrganization))
              commit('setOrgInfo', res.data.getOrganization)
            }
          })
          .catch((err) => {
            this.$store.commit('spinner', false)
            ErrorHandler(err, this)
            rej(err)
          })
      })
    },
  },
  mutations: {
    setOrgInfo(state, payload) {
      state.orgInfo = payload
    },
    setAuthState(state, { isLoggedIn, user }) {
      state.isLoggedIn = isLoggedIn
      state.user = user
    },
    setUserName(state, value) {
      state.registration.userInfo.name = value
    },
    setUserLastName(state, value) {
      state.registration.userInfo.lastName = value
    },
    setUserEmail(state, value) {
      state.registration.userInfo.email = value
    },
    setUserPassword(state, value) {
      state.registration.userInfo.password = value
    },
    setUserCellPhone(state, value) {
      state.registration.userInfo.cellPhone = value
    },
    setOrganizationId(state, value) {
      state.registration.userInfo.organizationId = value
    },
    setOrganizationScheme(state, value) {
      state.registration.userInfo.organizationScheme = value
    },
    setRegion(state, value) {
      state.registration.userInfo.region = value
    },
    setCountry(state, value) {
      state.registration.userInfo.country = value
    },
    setRegionSchemePresence(state, value) {
      state.registration.isRegionSchemePresent = value
    },
  },
}
